import React, { useEffect,useState } from 'react';

import { fetchData } from '../hooks/fetch/const_fetch';

import {setInfo} from './datainfo/dto';
import { validSesion } from './datainfo/dto';
import { URL,LOGIN } from './paths';
import { MD5 } from 'crypto-js';
import Loader from './loader/loader';
import './login.css'
import ChangePassMail from './ChangePassMail.jsx';

const Login=()=>{
    const[username,setUserName]=useState("");
    const[password,setPassword]=useState("");

    const[validuser,setValiduser]=useState("");
    const[validpass,setValidpass]=useState("");

    const [msgerr,setMsgErr] = useState("");
    const [loading,setLoading] = useState(false);

    const [isChangePassMail,setIsChangePassMail] = useState(false);
    const [userMail,setUserMail] = useState("");
/*
    if(validSesion()){
        window.location.assign('/inicio');
        return;
    } 
*/
    useEffect(()=>{
        if(validSesion()){
            window.location.assign('/home');
            return;
        }
    },[])

    const reset=()=>{
        setValidpass("");
        setValiduser("");
        setMsgErr("");
    }

    const IniciarSesion= async() => {
        try {
            reset();
            setLoading(true);
    
            if(username.trim().length === 0){
                setValiduser("is-invalid");
                setMsgErr("Por favor asigne usuario.");
                return;
            }else{
                setValiduser("is-valid");
            }
            if(password.trim().length === 0){
                setValidpass("is-invalid");
                setMsgErr("Por favor asigne contraseña.");
                return;
            }else{
                setValidpass("is-valid");
            }
          
          const url = URL + LOGIN; 
          const dtos = {
            strUserName: username,
            strUserPassword: MD5(password).toString().toUpperCase(),
          };
          
          const myHeaders = new Headers();
          myHeaders.append("Content-Type",  'application/json'); 
          
          const resultado =  await fetchData(url, 'POST', myHeaders, dtos); 
          //console.log("resultado",resultado)
          
            if(resultado.code === 1){
                resultado.usuario.blnNeedChangePassword = resultado.usuario.blnUserMustChangePassword
                setInfo(resultado);
                if(resultado.usuario.blnUserMustChangePassword == true){
                    setUserMail(resultado.usuario.strUserEmail)
                    setIsChangePassMail(true)
                    
                } else{
                    window.location.assign('/home');
                }
            }else{
              if(resultado === "signal is aborted without reason"){
                setMsgErr("Se agoto el tiempo de espera de la petición.");    
              }
                
              if(resultado.code === 0){
                setMsgErr(resultado.msg);    
              }else{
                //
                if(resultado.status === 404){
                    setMsgErr(`Servidor no encontrado.`);    
                }else if(resultado.code < 0){ 
                    setMsgErr(resultado.msg);
                }
              }
              setValiduser("is-invalid");
              setValidpass("is-invalid");
            }
        } catch (error) {
          setMsgErr(error.msg);   
        }
        finally{
            setLoading(false);
        } 
    }
    const handleUsernameChange = (event) => {
        setUserName(event.target.value.trim());
    };
    
    const handlePasswordChange = (event) => {
        setPassword(event.target.value.trim());
    };
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') { 
          IniciarSesion();
        }
    };
    return(
        <div className='contenedor'>
            { loading && <Loader/>}
            {isChangePassMail ? <ChangePassMail userMail={userMail} onClose={() => setIsChangePassMail(false)} /> : <></>}
            <div className="dotmenu"></div>
            <div className="contenedor_login" >
                <div className='container login'>
                        <h1 className="login_titulo ">INICIAR SESIÓN</h1>
                        <input 
                            type="text" 
                            id="username" 
                            onChange={handleUsernameChange} 
                            name="username" 
                            className={`form-control col-12 mb-2 ${validuser} `}
                            placeholder="Usuario" 
                            autoComplete='false' 
                            value={username} 
                        />
                        <input 
                            type="password" 
                            id="password"  
                            onChange={handlePasswordChange} 
                            name="password" 
                            className={`form-control col-12 mb-3 ${validpass} `}
                            placeholder="Constraseña" 
                            autoComplete='false' 
                            value={password} 
                            onKeyPress={handleKeyPress}
                        />
                            {msgerr &&
                                <div className="alert alert-danger hide">
                                    {msgerr}
                                </div>
                            }   
                        <button id="login" className='btn btn-primary fw-bold col-12'  onClick={IniciarSesion} >Iniciar sesión</button>
                </div> 
            </div>
        </div>
    )
}
 
export default Login;